import { useRoute } from 'vue-router';

const REDIRECT_STORAGE_PREFIX = 'gsd-now:not-found-redirect:';
const REDIRECT_WINDOW_MS = 10_000;

export function useNotFoundRedirect() {
  const route = useRoute();

  const isNotFoundError = error => error?.code === 'not_found' || error?.status === 404;

  const redirectOnNotFound = error => {
    if (!isNotFoundError(error) || typeof window === 'undefined') {
      return false;
    }

    const target = route.fullPath || `${window.location.pathname}${window.location.search}`;

    if (!markRedirectAttempt(target)) {
      return false;
    }

    window.location.replace(target);
    return true;
  };

  return {
    isNotFoundError,
    redirectOnNotFound,
  };
}

function markRedirectAttempt(target) {
  try {
    const key = `${REDIRECT_STORAGE_PREFIX}${target}`;
    const previousAttempt = Number(window.sessionStorage.getItem(key) || 0);
    const now = Date.now();

    if (now - previousAttempt < REDIRECT_WINDOW_MS) {
      return false;
    }

    window.sessionStorage.setItem(key, String(now));
    return true;
  } catch {
    return false;
  }
}
